import React, { Component } from 'react'
import { BrowserRouter, Redirect, Switch } from 'react-router-dom'
import { Provider } from 'react-redux'
import './App.css'
import { configureStore } from './redux/store'
import routes from './routes'

class App extends Component {
  render() {
    return (
      <Provider store={configureStore()}>
        <BrowserRouter>
          <div className='App'>
            <Switch>
              {routes}
              <Redirect from='*' to='/' />
            </Switch>
          </div>
        </BrowserRouter>
      </Provider>
    )
  }
}

export default App



// WEBPACK FOOTER //
// ./src/App.jsx